/**
 * We have similar statuses in fc-payment service too
 * Please make sure to update that service also when you update here
 */
export const PENDING_REMOTE_STATUSES = [
    "approval_pending",
    "incomplete",
    "past_due",
    "payer_action_required",
    "pending",
    "requires_confirmation",
    "requires_payment_method",
];

export const EVENT_BUS = {
    CANCEL_UPLOAD: "CANCEL_UPLOAD",
    RESTART_STUCK_JOB_WATCHER: "RESTART_STUCK_JOB_WATCHER",
};

export const DMCA_COPYRIGHTED_SOURCES = [
    "youtube.com",
    "googlevideo.com",
    "ytimg.com",
    "googleusercontent.com",
    "youtu.be",
    "netflix.com",
    "hulu.com",
    "primevideo.com",
    "disneyplus.com",
    "apple.com/tv",
    "hbomax.com",
    "vimeo.com",
    "dailymotion.com",
    "itunes.apple.com",
    "music.apple.com",
    "spotify.com",
    "music.amazon.com",
    "tidal.com",
    "deezer.com",
    "pandora.com",
    "soundcloud.com",
]

export const INTERRUPTED_JOBS_CHANNEL = "INTERRUPTED_JOBS_CHANNEL"
export const MAX_CONCURRENT_CONVERSIONS_DEFAULT = 5
export const EXPIRY_TIME_FOR_FILE_DOWNLOAD = 8
export const EXPIRY_TIME_FOR_RELOADED_FILE_DOWNLOAD = 2

export const PDF_PASSWORD_STATUS = {
    PROTECTED: 'protected',
    UNLOCKED: 'unlocked',
    INCORRECT: 'incorrect',
    OPEN: 'open'
}

export const PDF_INCLUDE_OPTIONS = [
    { label: 'all', value: 'all' },
    { label: 'manual_selection', value: 'custom' },
    { label: 'even_pages', value: 'even' },
    { label: 'odd_pages', value: 'odd' },
    { label: 'none', value: 'none' },
]

export const PDF_SPLIT_OPTIONS = [
    { label: 'manual_split', value: 'custom' },
    { label: 'by_page_range', value: 'range' },
    { label: 'fix_num_page_per_pdf', value: 'per_pdf' },
    { label: 'odd_even_pages', value: 'odd_even' },
    { label: 'split_in_half', value: 'half' },
    { label: 'extract_all_pages', value: 'all' },
]

export const AZURE_POLICIES = {
  signin: {
    name: "signin",
    errorRedirectUrl: "/auth/login",
  },
  signup: {
    name: "signup",
    errorRedirectUrl: "/auth/signup",
  },
  password_reset: {
    name: "password_reset",
    errorRedirectUrl: "/auth/login",
  },
  password_change: {
    name: "password_change",
    errorRedirectUrl: "/account",
  },
  google_signup_signin: {
    name: "google_signup_signin",
    errorRedirectUrl: "/auth/login",
  },
  disconnect_google: {
    name: "disconnect_google",
    errorRedirectUrl: "/account",
  },
  facebook_signup_signin: {
    name: "facebook_signup_signin",
    errorRedirectUrl: "/auth/login",
  },
  disconnect_facebook: {
    name: "disconnect_facebook",
    errorRedirectUrl: "/account",
  },
  set_password: {
    name: "set_password",
    errorRedirectUrl: "/account",
  },
  set_password_facebook: {
    name: "set_password_facebook",
    errorRedirectUrl: "/account",
  },
  logout: {
    name: "logout",
    errorRedirectUrl: "/",
  },
};

export const ROTATION_TEXTS = {
  '90': 'east',
  '180': 'south',
  '270': 'west'
}
